import { Column, ResponsiveContainer, Loader } from '@/components';
import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router';
import { useService } from '../../context';
import { ContentTab, Header, MainTab, OptionsTab, PricesTab, AvailabilityTab } from './components';
import { Button } from '@/components/Button/ButtonV2';
import { TabE } from '../../utils';

export const EditService: FunctionComponent = () => {
  const { activeTab, fullSubmit, isFetchingService, isMutationLoading, service, handleActiveTab } =
    useService();

  const navigate = useNavigate();

  React.useEffect(() => {
    if (service && activeTab === TabE.AVAILABILITY && !service.has_own_availability) {
      handleActiveTab(TabE.MAIN);
    }
  }, [service, activeTab, handleActiveTab]);

  const renderTab = () => {
    switch (activeTab) {
      case TabE.MAIN:
        return <MainTab />;
      case TabE.PRICES:
        return <PricesTab />;
      case TabE.CONTENT:
        return <ContentTab />;
      case TabE.AVAILABILITY:
        return service?.has_own_availability ? <AvailabilityTab /> : <MainTab />;
      case TabE.OPTIONS:
        return <OptionsTab />;
      default:
        return <MainTab />;
    }
  };

  return (
    <>
      {isFetchingService && <Loader fullScreen />}
      <Header />
      <Column className="w-full mx-auto min-h-[calc(100vh-124px)] bg-[#FBFBFB] pb-24 sm:pb-0">
        <ResponsiveContainer>{renderTab()}</ResponsiveContainer>
      </Column>

      {/* Sticky Footer */}
      <div className="fixed sm:relative bottom-0 left-0 right-0 flex justify-between gap-3 pt-4 pb-6 px-4 sm:px-0 sm:pt-4 bg-gradient-to-t from-white via-white to-transparent sm:bg-none sm:max-w-[672px] w-full mx-auto">
        <Button
          size="lg"
          variant="outline"
          className="flex-1 !text-base bg-white shadow-sm hover:bg-gray-50 h-14 sm:h-12 rounded-xl"
          onClick={() => navigate('/servicios')}
        >
          Volver
        </Button>
        <Button
          size="lg"
          className="flex-1 !text-base shadow-md hover:shadow-lg transition-all h-14 sm:h-12 rounded-xl bg-blue hover:bg-blue/90"
          isLoading={isMutationLoading}
          onClick={() => fullSubmit()}
        >
          Guardar
        </Button>
      </div>
    </>
  );
};
